import { render } from "./SOP_AcknowledgmentForm.vue?vue&type=template&id=6ceaefa4&scoped=true"
import script from "./SOP_AcknowledgmentForm.js?vue&type=script&lang=js"
export * from "./SOP_AcknowledgmentForm.js?vue&type=script&lang=js"

import "./SOP_AcknowledgmentForm.vue?vue&type=style&index=0&id=6ceaefa4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceaefa4"]])

export default __exports__